import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import InfoSvgComponent from "@assets/svg-components/info";
import { getValue } from "@utils/lodash";
import InputField from "@common/InputRuleFeild";

function ConfirmTripReportPopup(props: any) {
  const handleSubmit = () => {
    props.handleApproveReject();
  };

  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader>{"Confirm"}</ModalHeader>
      <div className="m-3">
        <div className="form-group" style={{ display: "flex", gap: "12px" }}>
          Are you sure want to {`${props.type}`} ?
        </div>
        {props?.exceptionDetails?.shouldShowExceptionLogic && (
          <div
            className="mb-3 p-3"
            style={{
              backgroundColor: "#f8d7da",
              border: "1px solid #f5c6cb",
              borderRadius: "4px",
            }}
          >
            <div className="d-flex align-items-center">
              <InfoSvgComponent size={24} color={"#dc3545"} />
              <span className="ms-2 text-danger small_text__14">
                This report crossed the {props?.exceptionDetails?.daysLimit}{" "}
                days limit, needs exceptional approval, please enter proper
                comments
              </span>
            </div>
          </div>
        )}

        {props?.exceptionDetails?.shouldShowExceptionLogic && (
          <div className="mb-3">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                id="exceptionApproval"
                checked={true}
                disabled={true}
                className="me-2"
              />
              <label
                htmlFor="exceptionApproval"
                className="small_text__14 mb-0"
              >
                Exception approval
              </label>
            </div>
          </div>
        )}

        {props.commentsRequired && (
          <div className="mt-3">
            <p className="small_text__14 mb-1">Reason *</p>
            <InputField
              inputType="TEXTAREA"
              name={"rejectComments"}
              onChange={(e: any) =>
                props.setComment(
                  e.target.value.length < 250
                    ? e.target.value
                    : getValue(props, `comment`, "")
                )
              }
              value={getValue(props, `comment`, "")}
              placeholder={"Enter Reason"}
            />
          </div>
        )}
      </div>

      <ModalFooter>
        <div className="delete-popup-wrapper__cta-wrapper">
          <button
            onClick={props.handleCancelModal}
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--secondary"
          >
            No
          </button>
          <button
            className="delete-popup-wrapper__cta-btn delete-popup-wrapper__cta-btn--primary"
            onClick={handleSubmit}
          >
            Yes
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmTripReportPopup;
